import {
  addressService
} from '../_services';

// importamos las traducciones para gestionar los avisos
import i18n from '../i18n.js';


const state = {

  addresses: null,
  loading: false,
  error: null,
  currentEditAddress: null

}

const actions = {

  createUserAddress({
    dispatch,
    commit
  }, objAddress) {

    commit('statusLoading', true);

    addressService.createUserAddress(objAddress)
      .then(
        data => {
          commit('createAddressOk', data);
          dispatch('notifier/success', i18n.t('notifier_created_address_ok'), {
            root: true
          });         
          dispatch('account/refreshUserData', true, { root : true });
        },
        error => {
          commit('createAddressKo', error);
          dispatch('notifier/error', error, {
            root: true
          })
        }
      )
  },

  updateUserAddress({
    dispatch,
    commit
  }, objAddress) {

    commit('statusLoading', true);

    addressService.updateUserAddress(objAddress)
      .then(
        data => {
          commit('updateAddressOk', data);
          dispatch('notifier/success', i18n.t('notifier_updated_address_ok'), {
            root: true
          });         
          dispatch('account/refreshUserData', true, { root : true });
        },
        error => {
          commit('updateAddressKo', error);
          dispatch('notifier/error', error, {
            root: true
          })
        }
      )
  },

  deleteUserAddress({
    dispatch,
    commit
  }, objAddress) {

    commit('statusLoading', true);

    addressService.deleteUserAddress(objAddress)
      .then(
        data => {
          commit('deleteAddressOk', data);
          dispatch('notifier/success', i18n.t('notifier_updated_address_ok'), {
            root: true
          });
        },
        error => {
          commit('deleteAddressKo', error);
          dispatch('notifier/error', error, {
            root: true
          });
        }
      )
  },

  getUserAddressById({
    commit
  }, addressId) {

    commit('statusLoading', true);  


    addressService.getUserAddress(addressId)
      .then(
        data => {        
          commit('getUserAddressByIdOk', data.data);
        /*   dispatch('notifier/success', i18n.t("recuperados_datos_correctamente"), {
            root: true
          }); */
        },
        error => {
          commit('getUserAddressByIdKo', error);
          /* dispatch('notifier/error', error, {
            root: true
          }); */
        }
      )
  }
};


const getters = {
  getCurrentEditAddress: state => state.currentEditAddress
};

const mutations = {

  statusLoading(state, status) {
    state.loading = status;
  },
  createAddressOk(state, address) {
    state.currentEditAddress = address;
    state.loading = false;
  },
  createAddressKo(state, error) {
    state.currentEditAddress = null;
    state.error = error;
    state.loading = false;
  },
  updateAddressOk(state, address) {
    state.currentEditAddress = address;
    state.loading = false;
  },
  updateAddressKo(state, error) {
    state.error = error;
    state.loading = false;
  },
  deleteAddressOk(state, address) {
    state.currentEditAddress = address;
    state.loading = false;
  },
  deleteAddressKo(state, error) {
    state.error = error;
    state.loading = false;
  },
  getUserAddressByIdOk(state, address) {    
    state.currentEditAddress = address;
    state.loading = false;
  },
  getUserAddressByIdKo(state, error) {
    state.error = error;
    state.loading = false;
  },

};


export const address = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}